// Switches a cart line between one-time and Subscribe & Save (snippets/n-cart-plan.liquid).
// In the drawer it switches in place and keeps the drawer open; on the cart page it
// reloads /cart. Without JS the form posts to /cart/change and comes back to /cart.
(function () {
  if (window.nCartPlanBound) return;
  window.nCartPlanBound = true;

  const json = (url, body) =>
    fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then((response) => response.json());

  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('form[data-n-cart-plan]');
    if (!form || !window.fetch) return;
    event.preventDefault();

    const trigger = event.submitter || document.querySelector(`[form="${form.id}"]`);
    if (trigger) {
      // A switch moves at once; the cart catches up.
      if (trigger.getAttribute('role') === 'switch') {
        trigger.setAttribute('aria-checked', trigger.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      }
      trigger.setAttribute('aria-busy', 'true');
      trigger.disabled = true;
    }
    const key = form.querySelector('[name="id"]').value;
    const plan = form.querySelector('[name="selling_plan"]').value;
    const cart = document.querySelector('cart-drawer');
    const inDrawer = cart && cart.contains(form) && typeof cart.getSectionsToRender === 'function';
    const sections = inDrawer ? cart.getSectionsToRender() : [];

    // Read the line's quantity now: it may have changed since the form was rendered,
    // and a plan change without it would reset the line to 1. A key doesn't change with quantity.
    json(`${window.routes.cart_url}.js`)
      .then((current) => {
        const line = current.items.find((item) => item.key === key);
        if (!line) return null;
        return json(`${window.routes.cart_change_url}.js`, {
          id: key,
          quantity: line.quantity,
          selling_plan: plan ? Number(plan) : null,
          sections: sections.map((section) => section.id),
          sections_url: window.location.pathname,
        });
      })
      .then((state) => {
        if (!inDrawer || !state || state.status || !state.sections) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        // Same swap as CartDrawer.renderContents, without reopening the open drawer.
        sections.forEach((section) => {
          const element = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (element && state.sections[section.id]) {
            element.innerHTML = cart.getSectionInnerHTML(state.sections[section.id], section.selector);
          }
        });
        const overlay = cart.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', cart.close.bind(cart));

        // Keep focus on the same line (lines can merge, so fall back to the first one).
        const line = document.getElementById(`CartDrawer-Item-${form.dataset.line}`) || cart.querySelector('.cart-item');
        const focusTarget = (line && line.querySelector('.cart-item__name')) || cart.querySelector('.drawer__close');
        if (typeof trapFocus === 'function') trapFocus(document.getElementById('CartDrawer'), focusTarget);
        else if (focusTarget) focusTarget.focus();
      })
      .catch(() => form.submit());
  });
})();
